
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.773 37.482h26.199l5.701-10H12.465","fill":"#FFF5E8"}}),_c('path',{attrs:{"d":"M6.773 37.482h26.199l5.701-10H12.465","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.854 4.167l-13.02 22.6 5.94 10.715s12.433-21.85 12.976-22.78","fill":"#FFF5E8"}}),_c('path',{attrs:{"d":"M13.854 4.167l-13.02 22.6 5.94 10.715s12.433-21.85 12.976-22.78","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M26.882 27.482h11.793L25.65 4.167H13.852c.549.94 13.029 23.315 13.029 23.315z","fill":"#fff","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    